t = require('app/scripts/views/internal/teacup-with-helpers')('header_overdue_banner')

module.exports = ->
  t.p '.u-bottom', ->
    t.format 'the-billing-information-for-team-is-out-of-date', { team: t.mustacheVar('team'), url: t.mustacheVar('billingUrl') }
    t.a '.header-banner-link-left.quiet.js-dismiss-overdue-banner.u-float-right', { href: "#" }, ->
      t.icon 'close'
